import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import PrivacyPolicySection from '../components/privacy/PrivacyPolicySection';
import { useSEO } from '../contexts/DataContext';
import SEO from '../components/layout/SEO';
import "../styles/privacy.css";
const PrivacyPage = () => {
  const seoData = useSEO('privacyPage', {
    title: 'Privacy Policy - Resumeslip',
    description: 'Learn how Resumeslip collects, uses, and protects your personal information.',
    meta_keywords: 'privacy policy, data protection, personal information, GDPR, privacy',
  });

  React.useEffect(() => {
    document.body.style.paddingTop = '50px';
    return () => {
      document.body.style.paddingTop = '0';
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="privacy-page">
        <SEO {...seoData} />
        <PrivacyPolicySection />
      </div>
    </HelmetProvider>
  );
};

export default PrivacyPage;